import "./style.scss";
import $ from "jquery";
import 'magnific-popup';
import 'magnific-popup/src/css/main.scss';

$.migrateMute = true;

$(document).ready(function () {
    $('.slider-gradiv__slider').slick({
        infinite: false,
        slidesToShow: 4,
        fade: false,
        dots: false,
        arrows: true,
        nextArrow: '<div class="ow_slick_arrow ah_front_next"><svg width="18" height="38" viewBox="0 0 18 38" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.21289 37.6538L16.8549 19.144L1.21289 0.634277" stroke="black"/> </svg></div>',
        prevArrow: '<div class="ow_slick_arrow ah_front_prev"><svg width="17" height="38" viewBox="0 0 17 38" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.4136 0.634277L0.771518 19.144L16.4136 37.6538" stroke="black"/> </svg></div>',
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 3,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            }
        ]
    });

    $(document).ready(function() {
        /*  Lightbox  */
        $('.lightbox-added').magnificPopup(ow_popup);
        var ow_popup = {
            type: 				'image',
            mainClass: 			'avia-popup mfp-zoom-in',
            tLoading: 			'',
            tClose: 			'',
            removalDelay: 		300, //delay removal by X to allow out-animation
            closeBtnInside: 	true,
            closeOnContentClick:false,
            midClick: 			true,
            fixedContentPos: 	false, // allows scrolling when lightbox is open but also removes any jumping because of scrollbar removal
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/watch',
                        id: function(url) {
                            //fetch the id
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/), id, params;
                            if ( !m || !m[1] ){ return null;}
                            id = m[1];
                            //fetch params
                            params = url.split('/watch');
                            params = params[1];
                            return id + params;
                        },
                        src: '//www.youtube.com/embed/%id%'
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: function(url) {
                            //fetch the id
                            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/), id, params;
                            if ( !m || !m[5] ) {return null;}
                            id = m[5];
                            //fetch params
                            params = url.split('?');
                            params = params[1];
                            return id + '?' + params;
                        },
                        src: '//player.vimeo.com/video/%id%'
                    }
                }
            },
            image: {
                titleSrc: function(item){
                    var title = item.el.attr('title');
                    if(!title) {title = item.el.find('img').attr('title');}
                    if(!title) {title = item.el.parent().next('.wp-caption-text').html();}
                    if(typeof title == "undefined") {return "";}
                    return title;
                }
            },
            gallery: {
                // delegate: 	options.autolinkElements,
                tPrev:		'',
                tNext:		'',
                tCounter:	'%curr% / %total%',
                enabled:	true,
                preload:	[1,1] // Will preload 1 - before current, and 1 after the current image
            },
            callbacks: {
                beforeOpen: function()
                {
                    //add custom css class for different styling
                    if( this.st.el && this.st.el.data('fixed-content') )
                    {
                        this.fixedContentPos = true;
                    }
                },
                open: function()
                {
                    //overwrite default prev + next function. Add timeout for  crossfade animation
                    $.magnificPopup.instance.next = function() {
                        var self = this;
                        self.wrap.removeClass('mfp-image-loaded');
                        setTimeout(function() { $.magnificPopup.proto.next.call(self); }, 120);
                    };
                    $.magnificPopup.instance.prev = function() {
                        var self = this;
                        self.wrap.removeClass('mfp-image-loaded');
                        setTimeout(function() { $.magnificPopup.proto.prev.call(self); }, 120);
                    };
                    //add custom css class for different styling
                    if( this.st.el && this.st.el.data('av-extra-class') )
                    {
                        this.wrap.addClass( this.currItem.el.data('av-extra-class') );
                    }
                },
                imageLoadComplete: function()
                {
                    var self = this;
                    setTimeout(function() { self.wrap.addClass('mfp-image-loaded'); }, 16);
                },
                change: function() {
                    if( this.currItem.el )
                    {
                        var current = this.currItem.el;

                        this.content.find( '.av-extra-modal-content, .av-extra-modal-markup' ).remove();

                        if( current.data('av-extra-content') )
                        {
                            var extra = current.data('av-extra-content');
                            this.content.append( "<div class='av-extra-modal-content'>" + extra + "</div>" );
                        }

                        if( current.data('av-extra-markup') )
                        {
                            var markup = current.data('av-extra-markup');
                            this.wrap.append( "<div class='av-extra-modal-markup'>" + markup + "</div>"  );
                        }
                    }
                }
            }
        }
    });
});